import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';
import { Toaster } from 'sonner';
import { CartDrawer } from './CartDrawer';
import { useCartStore } from '../store/cart';
export function Layout() {
  const {
    toggleCart,
    totalItems
  } = useCartStore();
  const itemsCount = totalItems();
  return <div className="min-h-screen flex flex-col font-sans bg-vsc-bg text-white" data-id="element-59">
      <Toaster position="top-center" theme="dark" toastOptions={{
      style: {
        background: '#171717',
        border: '1px solid #262626',
        color: '#fff'
      }
    }} data-id="element-60" />
      <CartDrawer data-id="element-61" />

      {/* Navbar */}
      <header className="border-b border-neutral-800 sticky top-0 z-50 bg-vsc-bg/80 backdrop-blur-md" data-id="element-62">
        <div className="max-w-7xl mx-auto px-4 h-20 flex items-center justify-between" data-id="element-63">
          <Link to="/" className="font-display text-3xl tracking-wider hover:text-vsc-gold transition-colors" data-id="element-64">
            VSC
          </Link>

          <nav className="hidden md:flex gap-8" data-id="element-65">
            <Link to="/" className="text-sm font-medium hover:text-vsc-gold transition-colors" data-id="element-66">
              Home
            </Link>
            <Link to="/shop" className="text-sm font-medium hover:text-vsc-gold transition-colors" data-id="element-67">
              Shop
            </Link>
            <Link to="/contact" className="text-sm font-medium hover:text-vsc-gold transition-colors" data-id="element-68">
              Contact
            </Link>
          </nav>

          <div className="flex items-center gap-4" data-id="element-69">
            <Link to="/shop" className="md:hidden text-sm font-medium hover:text-vsc-gold transition-colors" data-id="element-70">
              Shop
            </Link>
            <button onClick={toggleCart} className="p-2 hover:text-vsc-gold transition-colors relative" aria-label="Cart" data-id="element-71">
              <ShoppingBag size={20} data-id="element-72" />
              {itemsCount > 0 && <span className="absolute top-0 right-0 bg-vsc-gold text-black text-[10px] font-bold w-4 h-4 rounded-full flex items-center justify-center transform translate-x-1 -translate-y-1" data-id="element-73">
                  {itemsCount}
                </span>}
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow" data-id="element-74">
        <Outlet data-id="element-75" />
      </main>

      {/* Shared Footer */}
      <footer className="border-t border-neutral-800 py-12 mt-20" data-id="element-76">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-77">
          <div className="text-center md:text-left" data-id="element-78">
            <p className="font-display text-2xl tracking-wider mb-2" data-id="element-79">
              VSC Clothing
            </p>
            <p className="text-neutral-400 text-sm" data-id="element-80">
              VSCCLOTHING d/b/a VSC Clothing | 312 S 4th Street Downtown,
              Louisville, KY 40202
            </p>
            <a href="mailto:vscclothing5@gmail.com" className="text-neutral-400 text-sm hover:text-white transition-colors inline-block mt-1" data-id="element-81">
              vscclothing5@gmail.com
            </a>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-neutral-400" data-id="element-82">
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-83">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white transition-colors" data-id="element-84">
              Terms of Service
            </Link>
            <Link to="/sms-terms" className="hover:text-white transition-colors" data-id="element-85">
              SMS Terms
            </Link>
            <Link to="/contact" className="hover:text-white transition-colors" data-id="element-86">
              Contact
            </Link>
          </div>
        </div>
      </footer>
    </div>;
}